<div class="miq-quarter-selector-overlay">
  <div class="label">{{ label }}</div>
  <div class="months-quarters-header">
    @if (requiredYear) {
      <mat-form-field floatLabel="never" appearance="outline">
        <mat-select [(ngModel)]="selectedYear" (selectionChange)="otherYearSelected()" disableOptionCentering>
          <mat-select-trigger class="selected-year">
            {{ selectedYear }}
          </mat-select-trigger>
          @for (year of years; track year) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  @if (!isYearlySelector) {
    <div
      [ngClass]="{ 'monthly-selector': isMonthlySelector, 'quarter-selector': !isMonthlySelector }"
      class="months-quarters"
      >
      @for (quarter of quartersAndMonths; track quarter) {
        <div class="quarter" [class.disabled]="quarter.disabled" (click)="clickOnQuarter($event, quarter)">
          <span [class.selected]="thisSelection === quarter.value" class="quarter-title">
            {{ quarter.name }}
          </span>
          @for (month of quarter.months; track month) {
            <span
            [ngClass]="{
              selected: thisSelection === month.value,
              disabled: month.disabled,
            }"
              class="month"
              (click)="clickOnMonth($event, month)"
              >
              {{ month.name }}
            </span>
          }
        </div>
      }
    </div>
  }
</div>
